import React from 'react';
import { bathwareInfo } from '../mock';

export default function BathwareSection() {
  return (
    <section className="w-full relative bg-[#1a1a1a] text-white overflow-hidden">
      <div className="relative h-[480px] md:h-[560px]">
        <img src={bathwareInfo.hero} alt="Bathware" className="absolute inset-0 w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent" />
        <div className="relative h-full flex items-center px-8 md:px-20">
          <div className="max-w-xl">
            <div className="text-[11px] tracking-[0.4em] uppercase text-[#b48a3c] mb-4">Bathware</div>
            <h2 className="serif text-4xl md:text-5xl font-light leading-tight mb-5">{bathwareInfo.title}</h2>
            <p className="text-[15px] leading-relaxed opacity-90 mb-8 font-light">{bathwareInfo.description}</p>
            <a href="#" className="link-underline text-white">Discover More <span aria-hidden>&rarr;</span></a>
          </div>
        </div>
      </div>

      {/* Product strip */}
      <div className="grid grid-cols-1 md:grid-cols-3 bg-[#f6f1ea] text-[#1a1a1a]">
        {bathwareInfo.items.map((p) => (
          <a href="#" key={p.name} className="group block relative h-72 img-zoom border-r border-neutral-200 last:border-r-0">
            <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between text-white">
              <span className="text-sm tracking-[0.25em] uppercase font-medium">{p.name}</span>
              <span className="opacity-0 group-hover:opacity-100 transition-opacity">&rarr;</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
